import { getIcon } from "mt-components/icons";
import { MutableRefObject, useEffect, useRef, useState } from "react";
import { ProductInclusion } from "../../../../../../graphql/operations";
import { Text } from "../../../../../Atoms/Typography";
import s from "./Inclusion.module.scss";

type InclusionCardProps = Pick<
  ProductInclusion["translation"],
  "title" | "description"
> &
  Pick<ProductInclusion, "icon"> & {
    isExpanded: boolean;
    onReadMore: () => void;
  };

export default function InclusionCard({
  icon,
  title,
  description,
  isExpanded,
  onReadMore,
}: InclusionCardProps) {
  const descriptionRef = useRef(null);
  useEffect(() => {
    if (descriptionRef.current && descriptionRef.current.classList !== null) {
      descriptionRef.current.classList.toggle(s.Expanded, isExpanded);
      adjustDescriptionHeight(descriptionRef);
    }
  }, [isExpanded]);

  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const isTextOverflowing =
      descriptionRef.current.scrollHeight > descriptionRef.current.clientHeight;
    setIsOverflowing(isTextOverflowing);
  }, [isOverflowing]);

  useEffect(
    () =>
      window.addEventListener("resize", () =>
        adjustDescriptionHeight(descriptionRef)
      ),
    []
  );

  return (
    <>
      <div className={s.Card}>
        <div className={s.InclusionFields}>
          <div className={s.IconAndTitleFields}>
            {getIcon(icon, { style: { color: "#d81b60" } })}
            <Text bold size="medium">
              {title}
            </Text>
          </div>
          <div className={s.Description} ref={descriptionRef}>
            <Text size="small">{description}</Text>
          </div>
          {isOverflowing ? (
            <button className={s.ToggleExpansion} onClick={onReadMore}>
              {isExpanded ? "Read less" : "Read more"}
            </button>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
}

const adjustDescriptionHeight = (ref: MutableRefObject<any>) => {
  if (ref.current && ref.current.classList !== null) {
    if (ref.current.classList.contains(s.Expanded)) {
      ref.current.style.maxHeight = ref.current.scrollHeight + "px";
    } else {
      ref.current.style.maxHeight = "100px";
    }
  }
};
